import { render } from "./Charts.vue?vue&type=template&id=a3b82ed8"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"

import exportComponent from "/home/yandry/Downloads/s3-integration-app-web-prod(1)/s3-integration-app-web-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__